import { homeBannerList } from './home-banner-list/home-banner-list.module';
import { homeBannerAdd } from './home-banner-add/home-banner-add.module';
import { homeBannerEdit } from './home-banner-edit/home-banner-edit.module';
import { homeBannerMain } from './home-banner-main/home-banner-main.module';
import { homeBannerEditSequence } from './home-banner-edit-sequence/home-banner-edit-sequence.module';
import { HomeBannerService } from './home-banner.service';
import './home-banner.scss';

export const homeBanner = angular
	.module('components.homeBanner', [
		homeBannerList,
		homeBannerAdd,
		homeBannerEdit,
		homeBannerMain,
		homeBannerEditSequence
	])
	.service('HomeBannerService', HomeBannerService)
	.name;



// WEBPACK FOOTER //
// ./src/app/components/home-banner/home-banner.module.js